import { useSliderLayout } from '../hooks/useSliderLayout';

type SliderTrackContainerProps = { children: React.ReactNode };

const SliderTrackContainer = ({ children }: SliderTrackContainerProps) => {
	const { blockClass } = useSliderLayout();

	return (
		<div
			className={`sliderTrackContainer sliderTrackContainer--${blockClass} w-100 vtex-slider-layout-0-x-sliderTrackContainer vtex-slider-layout-0-x-sliderTrackContainer--${blockClass} overflow-hidden`}
		>
			{children}
		</div>
	);
};

export default SliderTrackContainer;
